import config from '../../../config/config';
import { PortalType } from '../../../config/enum';
import getRequest from '../base/get';
import postRequest from '../base/post';
import postRequestJson from '../base/postJson';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

/**
 * Derive the endpoint URL dynamically based on activePortal
 * @param {any} endpoint - The endpoint
 */
const getEndpointUrl = (endpoint: string) => {
  const activePortal = localStorage.getItem('activePortal');
  if (activePortal === PortalType.NETWORKS) {
    return `${config.cpo.commonApiUrl}api/common/v1/${endpoint}`;
  }
  return `${config.emsp.emspApiUrl}api/v1/${endpoint}`;
};

export default {
  /**
   * Fetch all payment gateways (master catalog).
   * @param {any} query - The query
   * @returns {any} Promise containing the payment gateways list.
   */
  fetchPaymentGatewaysList: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(getEndpointUrl('payment-gateways'), {
      ...parameters,
    });
  },
  /**
   * Fetch the configured payment gateways for this eMSP.
   * @returns {any} Promise containing configured payment gateways.
   */
  fetchPaymentGatewayConfigList: (): Promise<any> => {
    return getRequest(getEndpointUrl('payment-gateway-config'));
  },
  /**
   * Create or update a payment gateway configuration.
   * @param {any} data Payment gateway configuration data.
   * @returns {any} Promise containing the created payment gateway configuration.
   */
  createPaymentGateway: (data: any): Promise<any> => {
    const parameters = { ...data };

    return postRequestJson(getEndpointUrl('payment-gateway-config'), parameters, true);
  },

  /**
   * Activate or deactivate a payment gateway configuration.
   * @param {string} type Action type ('activate' or 'deactivate').
   * @param {string} id Payment gateway configuration ID (gatewayKey).
   * @param {any} data Optional request payload containing useCases to toggle.
   * @returns {any} Promise containing the operation result.
   */
  updatePaymentGatewayStatus: (type: string, id: string, data?: any): Promise<any> => {
    return postRequest(getEndpointUrl(`payment-gateway-config/${id}/${type}`), data);
  },
  /**
   * Update payment gateway configuration.
   * @param {any} data Payment gateway configuration data.
   * @returns {any} Promise containing the operation result.
   */
  updatePaymentGateway: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequestJson(getEndpointUrl('payment-gateway-config'), parameters, true);
  },
  /**
   * Fetch payment transactions with pagination and optional filters
   */
  fetchPaymentTransactionsList: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(getEndpointUrl('payment-transactions'), parameters);
  },
};
